import './noData.css'
import imagen from './no-find.png'

const languageSite = document.documentElement.lang

const NoData = () =>{
    return(
        <div className='block-no-find'>
           <h2 className='block-no-find__title'>{
           languageSite === 'en-US' ? 'Data not found' : 'Data no encontrada'}</h2>
           <div className='block-no__contente'>
                <img src={imagen} className='block-no__contente'  />
           </div>
        </div>
    )
}

export default NoData